/* unplugin-vue-components disabled */import script from "./fullWidthFeature.vue?vue&type=script&lang=js"
export * from "./fullWidthFeature.vue?vue&type=script&lang=js"

import "./fullWidthFeature.vue?vue&type=style&index=0&id=026a8ab4&lang=scss"

const __exports__ = script;

export default __exports__